import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

type Props = {
  projectId: string
  enabled?: boolean
}

export const useMyProject = ({ projectId, enabled = true }: Props) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['myProject', projectId],
    queryFn: () => projectService.project.getMyProject({ projectId }),
    enabled,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar os projetos',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      myProject: data,
      isLoading,
      refetchMyProject: refetch,
    }
  }

  return {
    myProject: null,
    isError,
    isLoading,
    refetchMyProject: refetch,
  }
}
